export const AREA_INSTRUCTIONS = 'instructions';
export const SECTION_TEXT = 'text';
export const SECTION_AUDIO = 'audio';
